import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import { CircularProgress, Typography, Paper, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import { useCarouselStyles } from './styles';
import {
  getProductsByCategory,
  getCurrentProductCategory,
} from '../../../../../../redux/actions/BankActions';
import { thousandsFormatter } from '../../../../../../helpers/BankHelper';

const CarrouselProducts = ({ ...props }) => {
  const { mobile, points } = props;
  const classes = useCarouselStyles();

  const dispatch = useDispatch();

  const {
    productsByCategoryStatus,
    productsByCategory,
    currentCategory,
  } = useSelector((state) => state.bankReducer);

  const [productValue, setProductValue] = useState(0);

  useEffect(() => {
    if (productsByCategory.length) {
      dispatch(getCurrentProductCategory(productsByCategory[productValue]));
    }
  }, [productValue]);

  useEffect(() => {
    if (productsByCategory.length) {
      dispatch(getCurrentProductCategory(productsByCategory[0]));
    }
  }, [productsByCategory]);

  useEffect(() => {
    if (Object.keys(currentCategory).length) {
      dispatch(getProductsByCategory(currentCategory.categoryId));
    }
  }, [currentCategory]);

  const isPointsRemainingError = (product) =>
    Math.sign(product.points - Number(points)) > 0;

  const calcCarouselSettings = () => {
    const settings = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      nextArrow: <KeyboardArrowRightIcon fontSize="large" color="secondary" />,
      prevArrow: <KeyboardArrowLeftIcon fontSize="large" color="secondary" />,
      beforeChange: (old, current) => {
        setProductValue(current);
      },
    };
    if (window.innerWidth >= 769) {
      return { ...settings, centerMode: true, centerPadding: '80px' };
    }
    return settings;
  };

  return (
    <>
      {productsByCategoryStatus === 'loading' && <CircularProgress />}
      {productsByCategoryStatus === 'error' && (
        <>
          <div className="description">
            No tenemos productos disponibles para canjear en esta categoría.
          </div>
        </>
      )}
      {productsByCategoryStatus === 'succeded' && (
        <div className={classes.carouselProducts}>
          <Slider {...calcCarouselSettings()}>
            {productsByCategory.map((product, index) => (
              <Paper className={classes.root} elevation={0} key={product.id}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <img
                    data-cy={`carouselProduct-${product.id}`}
                    src={product.image}
                    className={`${classes.carouselImg} ${
                      mobile ? classes.imageMobile : classes.imageProductDesktop
                    } ${
                      isPointsRemainingError(product)
                        ? classes.imageDisabled
                        : ''
                    }`}
                  />
                  <Typography className={classes.stock}>
                    Stock disponible: {product.stock}
                  </Typography>
                  {productValue === index && (
                    <>
                      <Typography className={classes.title}>
                        {product.title}
                      </Typography>
                      <Typography className={classes.subtitle}>
                        {product.subtitle}
                      </Typography>
                      {isPointsRemainingError(product) && (
                        <Typography className={classes.pointsRemainingError}>
                          Te faltan{' '}
                          {thousandsFormatter(product.points - Number(points))}{' '}
                          puntos ¡Sigue acumulando!
                        </Typography>
                      )}
                    </>
                  )}
                </Box>
              </Paper>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

CarrouselProducts.propTypes = {
  mobile: PropTypes.bool,
  points: PropTypes.number,
};

export default CarrouselProducts;
